import makeApiCall from "./axiosIndex";

const uomApis = {
  addUOM: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: `/buyer/createUom`,
      data,
    }),
  fetchUomById: (id: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/buyer/findUomById?id=${id}`,
    }),
  fetchAllUom: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: "/buyer/findAllUom",
    }),
  fetchAllUomByOrg: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: "/buyer/findAllUomWithOrg",
    }),
  updateUOM: (data: any, id: any): Promise<any> =>
    makeApiCall<any>({
      method: "put",
      url: `/buyer/updateUom`,
      data,
      params: { id },
    }),
  removeUOM: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "delete",
      url: `/buyer/deleteUom`,
      params: { id },
    }),
};

export default uomApis;